var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenchmarkingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.001,
    height: 17.815,
    viewBox: "0 0 19.001 17.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28849",
    "data-name": "Group 28849",
    transform: "translate(-123.601 -3.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8901",
    "data-name": "Rectangle 8901",
    transform: "translate(123.601 12.364)",
    fill: "none",
    stroke: "#4b74be",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8.908,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 7.408,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8902",
    "data-name": "Rectangle 8902",
    transform: "translate(130.601 3.456)",
    fill: "none",
    stroke: "#4b74be",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17.814,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 16.314,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8903",
    "data-name": "Rectangle 8903",
    transform: "translate(137.601 7.205)",
    fill: "none",
    stroke: "#4b74be",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 14.065,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 12.565,
    rx: 1.25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkingActive);
export default __webpack_public_path__ + "static/media/BenchmarkingActive.812d9f4f8c6da1dfaf535c9235ec6cfa.svg";
export { ForwardRef as ReactComponent };